export default __webpack_public_path__ + "static/media/handwovenpitloom.b8abd3a8.jpg";